export interface FluidFilterItem {
    label: string
    status: string
    options: string[]
}

function fluid(label: string, options: string[]): FluidFilterItem {
    return { label, status: '', options }
}

export class MechanicInspection {
    id?: string
    workOrderNumber = ''
    equipmentId = ''
    dateTime: Date | null = new Date()
    mechanic: number = 0
    hours = ''

    verifyComplaint = ''
    verifyComplaintNotes = ''

    visualInspectionFindings: string[] = []
    visualInspectionNotes = ''

    fluidsFilters: FluidFilterItem[] = [
        fluid('Engine Oil', ['OK', 'Low', 'Dirty']),
        fluid('Coolant', ['OK', 'Low', 'Contaminated']),
        fluid('Hydraulic Oil', ['OK', 'Low', 'Dirty']),
        fluid('Fuel', ['OK', 'Contaminated']),
        fluid('Air Filter', ['OK', 'Plugged']),
        fluid('Fuel Filter', ['OK', 'Plugged']),
    ]

    engineSymptoms: string[] = []
    excessSmokeColor = ''
    engineBasicChecks: string[] = []

    hydraulicSymptoms: string[] = []
    hydraulicChecks: string[] = []

    electricalChecks: string[] = []
    faultCodes = ''

    drivetrainSymptoms: string[] = []

    brakeFindings: string[] = []

    coolingFindings: string[] = []

    attachmentFindings: string[] = []

    causeIdentified = ''
    causeDescription = ''

    status = ''

    mechanicNotes = ''
}
